import { render, staticRenderFns } from "./SGPContainerComponent.vue?vue&type=template&id=10d27fab"
import script from "./SGPContainerComponent.vue?vue&type=script&lang=js"
export * from "./SGPContainerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports